import { BillingTransferRequestType } from "@common/constants/domains/billing/billingTransferRequest";
import { Organization } from "@common/types/organization";
import { useActiveWorkspaceDetails } from "@hooks/useActiveWorkspaceDetails";
import { useMemo } from "react";

export function useTransferRequestsForClientResolution() {
    const activeWorkspaceDetails = useActiveWorkspaceDetails();

    return useMemo(() => {
        if (!activeWorkspaceDetails) {
            return [];
        }

        const organizationById =
            activeWorkspaceDetails.organizationAssignments.reduce(
                (acc, oa) => {
                    acc[oa.organizationId] = oa.organization as Organization;
                    return acc;
                },
                {} as Record<string, Organization>,
            );

        return activeWorkspaceDetails.pendingTransferRequests
            .filter(
                (request) =>
                    request.type ===
                    BillingTransferRequestType.WORKSPACE_TO_ORGANIZATION,
            )
            .map((request) => ({
                request,
                organization: organizationById[request.organizationId],
            }));
    }, [activeWorkspaceDetails]);
}
